import css from 'styled-jsx/css';

const styles = css.global`.blog-tx-list p,
.blog-tx-list p b {
  /* max-width: 288px; */
  color: #222222;
  font-family: 'SantanderText';
  font-size: 18px;
  letter-spacing: 0;
  line-height: 26px;
  text-align: left;
  margin: 0 0 24px 0;
}

.blog-tx-list p b {
  font-weight: 600;
}

.blog-tx-list ul {
  margin: 0;
}

.blog-tx-list p a {
  color: #cc0000;
  font-family: 'SantanderText';
  text-decoration: underline;
  cursor: pointer;
}

.blog-tx-list h3 {
  /* max-width: 288px; */
  color: #222222;
  font-family: 'SantanderHeadline';
  font-size: 18px;
  letter-spacing: 0;
  line-height: 24px;
  text-align: center;
  text-align: left;
  margin: 0 0 24px 0;
}

@media (min-width: 992px) {
  .blog-tx-list p {
    max-width: 757px;
    color: #444444;
  }

  .blog-tx-list h3 {
    max-width: 691px;
    color: #222222;
    font-family: 'SantanderHeadline';
    font-size: 24px;
    letter-spacing: 0;
    line-height: 36px;
  }

  .blog-tx-list ul p {
    max-width: 710px;
  }
}
`;

export default styles;